import { NgModule } from '@angular/core';
import { PopupsComponent } from './popups.component';
import { LevelStatusComponent } from './level-status/level-status.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'projects/shared/src/lib/shared.module';
import { RouterModule } from '@angular/router';
import { PopupsRoutes } from './popups.routing';
import { NgMaterialModule } from 'projects/main/src/app/ng-material.module';

@NgModule({
  declarations: [PopupsComponent, LevelStatusComponent],
  imports: [
    CommonModule,
    NgMaterialModule,
    SharedModule,
    RouterModule.forChild(PopupsRoutes)
  ],
  exports: [PopupsComponent]
})
export class PopupsModule { }
